import angular from 'angular';
import template from './template.html';

export class DialogPlaceholder {
    modalDialogs = [];

    /* @ngInject */
    constructor(ModalDialogService, $scope) {
        ModalDialogService.registerPlaceholder(this);
        this.$scope = $scope;
    }

    addDialog(dialog) {
        const dialogId = dialog.modalDialogId;

        if (this.modalDialogs.find(dialog => dialog.modalDialogId === dialogId)) {
            throw new Error(`${dialogId} already shown`);
        }

        this.modalDialogs.push(dialog);
    }

    removeDialog(dialog) {
        const dialogId = dialog.modalDialogId;
        const dialogIndex = this.modalDialogs.findIndex(dialog => dialog.modalDialogId === dialogId);

        if (dialogIndex > -1) {
            this.modalDialogs.splice(dialogIndex, 1);
        } else {
            throw new Error(`${dialogId} not shown`);
        }
    }
}

export const DialogPlaceholderConfiguration = {
    template,
    controller: DialogPlaceholder,
    controllerAs: 'dialogPlaceholderCtrl',
};

angular.module('TALENYA-FE').component('dialogPlaceholder', DialogPlaceholderConfiguration);
